import {
  FETCH_WALLET_BALANCE_REQUEST,
  FETCH_WALLET_BALANCE_SUCCESS,
  FETCH_WALLET_BALANCE_FAILURE,
  TOP_UP_WALLET_REQUEST,
  TOP_UP_WALLET_SUCCESS,
  TOP_UP_WALLET_FAILURE,
  UPDATE_AUTO_REFILL_SETTINGS_REQUEST,
  UPDATE_AUTO_REFILL_SETTINGS_SUCCESS,
  UPDATE_AUTO_REFILL_SETTINGS_FAILURE,
  FETCH_WALLET_TRANSACTIONS_REQUEST,
  FETCH_WALLET_TRANSACTIONS_SUCCESS,
  FETCH_WALLET_TRANSACTIONS_FAILURE,
  ESTIMATE_USAGE_COST_REQUEST,
  ESTIMATE_USAGE_COST_SUCCESS,
  ESTIMATE_USAGE_COST_FAILURE,
  FETCH_WALLET_ANALYTICS_REQUEST,
  FETCH_WALLET_ANALYTICS_SUCCESS,
  FETCH_WALLET_ANALYTICS_FAILURE,
  WALLET_INVOICES,
  WALLET_INVOICE
} from '@/store/actions/wallet.actions';

const initialState = {
  balance: 0,
  transactions: [],
  transactionsPagination: {
    currentPage: 1,
    perPage: 20,
    totalPages: 1,
    totalCount: 0
  },
  invoice: {},
  invoices: [],
  invoices_meta: [],
  autoRefillSettings: {
    enabled: false,
    threshold: 10,
    amount: 50
  },
  costEstimates: {},
  analytics: null,
  loading: {
    balance: false,
    topup: false,
    autoRefill: false,
    transactions: false,
    invoices: false,
    estimate: false,
    analytics: false
  },
  error: {
    balance: null,
    topup: null,
    autoRefill: null,
    transactions: null,
    invoices: null,
    estimate: null,
    analytics: null
  }
};

export default function wallet(state = initialState, action) {
  switch (action.type) {
    case FETCH_WALLET_BALANCE_REQUEST:
      return { ...state, loading: { ...state.loading, balance: true }, error: { ...state.error, balance: null } };
    case FETCH_WALLET_BALANCE_SUCCESS:
      return {
        ...state,
        loading: { ...state.loading, balance: false },
        balance: action.payload.data.balance,
        remainingEmailAllowance: action.payload.data.remaining_email_allowance,
        totalEmailAllowance: action.payload.data.total_email_allowance,
        autoRefillSettings: action.payload.data.auto_refill_settings || {
          enabled: false,
          threshold: 10,
          amount: 50
        }
      };
    case FETCH_WALLET_BALANCE_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, balance: false },
        error: { ...state.error, balance: action.payload }
      };

    case TOP_UP_WALLET_REQUEST:
      return { ...state, loading: { ...state.loading, topup: true }, error: { ...state.error, topup: null } };
    case TOP_UP_WALLET_SUCCESS:
      return { ...state, loading: { ...state.loading, topup: false } };
    case TOP_UP_WALLET_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, topup: false },
        error: { ...state.error, topup: action.payload }
      };

    case UPDATE_AUTO_REFILL_SETTINGS_REQUEST:
      return { ...state, loading: { ...state.loading, autoRefill: true }, error: { ...state.error, autoRefill: null } };
    case UPDATE_AUTO_REFILL_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: { ...state.loading, autoRefill: false },
        autoRefillSettings: action.payload.data?.auto_refill_settings || action.payload
      };
    case UPDATE_AUTO_REFILL_SETTINGS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, autoRefill: false },
        error: { ...state.error, autoRefill: action.payload }
      };

    case FETCH_WALLET_TRANSACTIONS_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, transactions: true },
        error: { ...state.error, transactions: null }
      };
    case FETCH_WALLET_TRANSACTIONS_SUCCESS:
      const responseData = action.payload.data || action.payload;
      // Convert snake_case from backend to camelCase for frontend
      const pagination = responseData.pagination
        ? {
            currentPage: responseData.pagination.current_page || 1,
            perPage: responseData.pagination.per_page || 20,
            totalPages: responseData.pagination.total_pages || 1,
            totalCount: responseData.pagination.total_count || 0
          }
        : {
            currentPage: 1,
            perPage: 20,
            totalPages: 1,
            totalCount: 0
          };
      return {
        ...state,
        loading: { ...state.loading, transactions: false },
        transactions: responseData.transactions || [],
        transactionsPagination: pagination
      };
    case FETCH_WALLET_TRANSACTIONS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, transactions: false },
        error: { ...state.error, transactions: action.payload }
      };

    case ESTIMATE_USAGE_COST_REQUEST:
      return { ...state, loading: { ...state.loading, estimate: true }, error: { ...state.error, estimate: null } };
    case ESTIMATE_USAGE_COST_SUCCESS:
      return {
        ...state,
        loading: { ...state.loading, estimate: false },
        costEstimates: { ...state.costEstimates, [action.payload.usageType]: action.payload.data }
      };
    case ESTIMATE_USAGE_COST_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, estimate: false },
        error: { ...state.error, estimate: action.payload }
      };

    case FETCH_WALLET_ANALYTICS_REQUEST:
      return { ...state, loading: { ...state.loading, analytics: true }, error: { ...state.error, analytics: null } };
    case FETCH_WALLET_ANALYTICS_SUCCESS:
      return { ...state, loading: { ...state.loading, analytics: false }, analytics: action.payload };
    case FETCH_WALLET_ANALYTICS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, analytics: false },
        error: { ...state.error, analytics: action.payload }
      };
    case WALLET_INVOICES:
      return {
        ...state,
        invoices: action.payload.data,
        invoices_meta: action.payload.meta
      };
    case WALLET_INVOICE:
      return {
        ...state,
        invoice: action.payload.data
      };
    default:
      return state;
  }
}

export const getWalletBalance = state => state?.wallet?.balance;
export const getWalletTransactions = state => state?.wallet?.transactions;
export const getWalletTransactionsPagination = state => state?.wallet?.transactionsPagination;
export const getWalletInvoices = state => state?.wallet?.invoices;
export const getAutoRefillSettings = state => state?.wallet?.autoRefillSettings;
export const getCostEstimates = state => state?.wallet?.costEstimates;
export const getWalletAnalytics = state => state?.wallet?.analytics;
export const getWalletLoading = state => state?.wallet?.loading;
export const getWalletErrors = state => state?.wallet?.error;
